module.exports = __webpack_public_path__ + "img/ELSAN-2.8fb05ee9.png";